import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LogoService {
  logo = signal<string | null>(null);

  setLogo(url: string): void {
    this.logo.set(url);
  }

  clearLogo(): void {
    this.logo.set(null);
  }
}
